module.exports = __webpack_public_path__ + "img/kuai.1120966b.png";